<div>
  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px" [formGroup]="quizForm">
    <mat-form-field>
      <mat-label>Enter URL</mat-label>
    <input matInput type="url"  formControlName="url" name="url" style="width: 200px;"/>
    </mat-form-field>
  </div>
  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="generate()">Ok</button>
  </div>
</div>
